import { useState } from 'react';
// eslint-disable-next-line
import { unstable_batchedUpdates } from 'react-dom';

const useFormSubmission = () => {
    const [formError, setFormError] = useState(``);
    const [hasFormError, setHasFormError] = useState(false);

    const setFormState = (error: string) => {
        unstable_batchedUpdates(() => {
            setFormError(error);
            setHasFormError(true);
        });
    };

    const clearFormState = () => {
        unstable_batchedUpdates(() => {
            setFormError(``);
            setHasFormError(false);
        });

    };

    return { setFormState, clearFormState, hasFormError, formError };
};

export default useFormSubmission;
